import { format } from 'date-fns'
import { useSigningForm } from '../Provider'
import { BindingField } from './BindingField'
import { SigningFormFieldProps } from './Switcher'

export const SignatureDateField = (props: SigningFormFieldProps) => {
  const form = useSigningForm()

  const signatureDate = form.watch(props.path)

  if (!signatureDate) return

  return (
    <p
      style={{
        fontSize: 'inherit',
      }}
    >
      {format(new Date(signatureDate), 'dd/MM/yyyy')}
    </p>
  )
}
